import type { ContentPage } from "@/lib/content/types";

export const email: ContentPage = {
  slug: "omni-channels/email",
  template: "hrmsFeature",
  seo: {
    title: "CRM Email Integration - Send, Track & Automate Email | GetBiz CRM",
    description:
      "Connect your inbox to GetBiz CRM to send, receive and track every email against the right contact and deal — with templates, tracking and automation built in.",
    keywords: [
      "CRM email integration",
      "email tracking software",
      "sales email software",
      "email templates CRM",
      "two-way email sync",
      "email automation",
    ],
    ogImage: "/assets/data/seoimages/email.webp",
  },
  leaf: {
    hero: {
      caption: "Email",
      title: "Every Email, On the Right Record",
      description:
        "Send and receive email inside GetBiz CRM with two-way sync, open and click tracking, templates and automation — so your whole team sees the full conversation history.",
      h1: "caption",
    },
    split: {
      title: "Email That Works With Your Pipeline",
      bullets: [
        { title: "Two-way Sync", description: "Emails log automatically against the contact." },
        { title: "Open & Click Tracking", description: "Know when prospects engage." },
        { title: "Templates & Snippets", description: "Send on-brand emails in seconds." },
        { title: "Automated Sends", description: "Trigger emails from workflows and cadences." },
      ],
      image: "/assets/images/img/product/crm/email-lead-image.webp",
      imageAlt: "GetBiz CRM email integration",
    },
    cardsHeading: { title: "More Omni Channels", description: "Email works with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "Telephony", href: "/crm-software/omni-channels/telephony/", description: "Call and log conversations from the CRM.", image: "/assets/images/img/product/crm/telephony.webp", imageAlt: "CRM telephony" },
      { title: "SMS", href: "/crm-software/omni-channels/sms/", description: "Follow up by text alongside email.", image: "/assets/images/img/product/crm/sms.webp", imageAlt: "CRM SMS" },
      { title: "WhatsApp", href: "/crm-software/omni-channels/whatsapp/", description: "Chat on WhatsApp from the same inbox.", image: "/assets/images/img/product/crm/whatsapp.webp", imageAlt: "CRM WhatsApp" },
      { title: "Live Chat", href: "/crm-software/omni-channels/live-chat/", description: "Capture website chats into the CRM.", image: "/assets/images/img/product/crm/live-chat.webp", imageAlt: "CRM live chat" },
    ],
    testimonials: { title: "Full email context", description: "See why teams run email through GetBiz CRM." },
    bookDemoTitle: "Bring your email into the CRM.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "email-integration-crm-guide, sales-email-tracking-guide",
    metaKey: "email",
  },
  sections: [],
};
